import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import * as Commands from "../../../../../model/commands"
import { ID } from "../../../../../model/types"
import { useNana } from "../../../../hooks/useNana"
import { MosaicPageState } from "../../mosaic"
import MoveCard, {
  CardMeta,
  CardPreviewText,
  CardPrimaryButton,
  CardSecondaryButton,
  previewFromHtml,
} from "../move_card"

export default function PlaceCard({
  fleetingId,
  onReroll,
  onObjectGone,
}: {
  fleetingId: ID
  onReroll: () => void
  onObjectGone: () => void
}) {
  const { model, commander } = useNana()
  const navigate = useNavigate()
  const fleeting = model.getFleetingIdea(fleetingId)

  useEffect(() => {
    if (!fleeting) onObjectGone()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fleeting])

  if (!fleeting) return null

  const open = () => {
    MosaicPageState.openFleetingPanel = true
    MosaicPageState.highlightFleetingId = fleeting.id
    navigate("/app")
  }

  const discard = () => {
    if (!window.confirm("Discard this note?")) return
    commander.exec(new Commands.DeleteFleetingIdeaCommand({ id: fleeting.id }))
    onObjectGone()
  }

  const source = fleeting.sourceId ? model.getSource(fleeting.sourceId) : null
  const sourceLabel =
    source?.name ||
    source?.userProvidedName ||
    source?.scannedName ||
    source?.url

  return (
    <MoveCard
      move="place"
      onReroll={onReroll}
      onPrimary={open}
      actions={
        <>
          <CardPrimaryButton onClick={open}>Place on mosaic</CardPrimaryButton>
          <CardSecondaryButton onClick={discard}>Discard</CardSecondaryButton>
        </>
      }
    >
      <div className="flex min-h-[7.5rem] flex-1 flex-col gap-3">
        <CardPreviewText lines={6}>
          {previewFromHtml(fleeting.content) || "Empty note"}
        </CardPreviewText>
        <CardMeta>
          <span>Drag onto the mosaic</span>
          {sourceLabel && (
            <span className="truncate opacity-70">from {sourceLabel}</span>
          )}
        </CardMeta>
      </div>
    </MoveCard>
  )
}
